<template>
    <div v-if="loaded" class="container bng-promotions">
        <ul class="banners">
            <!-- <deposit-bonus-banner v-if="isDepositBonusActive" />
            <registration-bonus-banner v-if="isRegistrationBonusActive" />
            <cashback-bonus-banner v-if="isCashbackBonusActive" />
            <email-bonus-banner v-if="isEmailBonusActive" /> -->
            <li v-if="theme != 'luckerhub' && theme != 'cashcasino'" class="banners-cell">
                <div class="banners-cell__image">
                    <img src="/static/promotions/deposit-100-min.jpg" alt="deposit" class="banners-cell__img">
                </div>
                <div class="banners-cell__inner">
                    <div class="banners-cell__content">
                        <h2 class="banners-cell__title">Deposit Bonus</h2>
                        <p class="banners-cell__text">Don't miss out: 100% bonus on every deposit - daily!</p>
                    </div>
                    <div class="banners-cell__buttons">
                        <router-link :to="{ name: 'promotions-deposit'}" class="banners-cell__button banners-cell__button--readmore">
                            Read more...
                        </router-link>
                    </div>
                </div>
            </li>
            <li v-if="theme == 'luckerhub' || theme == 'cashcasino'" v-for="n in 3" class="banners-cell">
                <div class="banners-cell__image">
                    <img src="/static/banner.jpg" alt="deposit" class="banners-cell__img">
                </div>
                <div class="banners-cell__inner">
                    <div class="banners-cell__content">
                        <h2 class="banners-cell__title">BONUS $150</h2>
                        <p class="banners-cell__text">Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et massa mi..</p>
                    </div>
                    <div class="banners-cell__buttons">
                        <router-link :to="{ name: 'promotions-welcome-bonus'}" class="banners-cell__button banners-cell__button--readmore">
                            MORE INFO
                        </router-link>
                        <a
                            @click="goToBonusRules()"
                            class="banners-cell__button banners-cell__button--access">ACCESS</a>
                    </div>
                </div>
            </li>
            <!-- <li class="banners-cell">
                <div class="banners-cell__image">
                    <img src="/static/promotions/aviatrix_september-min.jpg" alt="fly high" class="banners-cell__img">
                </div>
                <div class="banners-cell__inner">
                    <div class="banners-cell__content">
                        <h2 class="banners-cell__title">Fly High, Conquer the Sky!</h2>
                        <p class="banners-cell__text">The captivating tournament from Aviatrix</p>
                    </div>
                    <div class="banners-cell__buttons">
                        <div class="banners-cell__button" @click="openGame(game)">Bet now</div>
                        <router-link :to="{ name: 'promotions-fly-high'}" class="banners-cell__button banners-cell__button--readmore">
                            Read more...
                        </router-link>
                    </div>
                </div>
            </li>
            <li class="banners-cell disactive">
                <div class="banners-cell__image">
                    <img src="/static/promotions/aviatrix_august-min.jpg" alt="get cash" class="banners-cell__img">
                </div>
                <div class="banners-cell__inner">
                    <div class="banners-cell__content">
                        <h2 class="banners-cell__title">Get cash, before you crash!</h2>
                        <p class="banners-cell__text">Make the best use of perfect flying conditions.</p>
                    </div>
                    <div class="banners-cell__buttons">
                        <div class="banners-cell__button" @click="openGame(game)">Bet now</div>
                        <router-link :to="{ name: 'promotions-get-cash' }" class="banners-cell__button banners-cell__button--readmore">
                            Read more...
                        </router-link>
                    </div>
                </div>
            </li> -->
        </ul>
    </div>
</template>
<script>
import Vue from 'vue';

import DepositBonusBanner from '../../../common/banners/sport-banners/deposit-bonus.vue';
import RegistrationBonusBanner from '../../../common/banners/sport-banners/registration-bonus.vue';
import CashbackBonusBanner from '../../../common/banners/sport-banners/cashback-bonus.vue';
import EmailBonusBanner from '../../../common/banners/sport-banners/email-bonus.vue';

export default {
    name: 'bk-bonuses',
    components: { DepositBonusBanner, RegistrationBonusBanner, CashbackBonusBanner, EmailBonusBanner },
    data() {
        return {
            loaded: false,
            isDepositBonusActive: false,
            isRegistrationBonusActive: false,
            isCashbackBonusActive: false,
            isEmailBonusActive: false,
            theme: null,
            game: {
                "provider": "aviatrix",
                "gameId": "aviatrix"
            }
        };
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
    },
    async created() {
        await Vue.state.client.ensure();
        let client = Vue.state.client.get();
        this.isDepositBonusActive = client.bonus && client.bonus.deposit;
        this.isRegistrationBonusActive = client.bonus && client.bonus.registration;
        this.isCashbackBonusActive = client.bonus && client.bonus.cashback;
        this.isEmailBonusActive = client.bonus && client.bonus.mailing;
        this.loaded = true;
        this.theme = (this.client && this.client.view && this.client.view.style.theme) || 'dark';
    },
    methods: {
        async openGame(game) {
            await Vue.router.teleport.game(game);
        },
        async goToBonusRules() {
            await Vue.router.teleport.bonusRules();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/promotions/promotions.vue